export class CampaignSummaryMetricsBuilder {
  constructor() {
    this.metrics = {};
  }

  setTotalRevenue(totalRevenue) {
    this.metrics.totalRevenue = totalRevenue;
    return this;
  }

  setAttributedRevenue(attributedRevenue) {
    this.metrics.attributedRevenue = attributedRevenue;
    return this;
  }

  setRevenuePerRecipient(revenuePerRecipient) {
    this.metrics.revenuePerRecipient = revenuePerRecipient;
    return this;
  }

  setLtvIncreaseRatio(ltvIncreaseRatio) {
    this.metrics.ltvIncreaseRatio = ltvIncreaseRatio;
    return this;
  }

  setWinbackRevenue(winbackRevenue) {
    this.metrics.winbackRevenue = winbackRevenue;
    return this;
  }

  setAdditionalRevenue(additionalRevenue) {
    this.metrics.additionalRevenue = additionalRevenue;
    return this;
  }

  setAttributedWinbacks(attributedWinbacks) {
    this.metrics.attributedWinbacks = attributedWinbacks;
    return this;
  }

  setAttributedRevenuePerRecipient(attributedRevenuePerRecipient) {
    this.metrics.attributedRevenuePerRecipient = attributedRevenuePerRecipient;
    return this;
  }

  setWinbacks(winbacks) {
    this.metrics.winbacks = winbacks;
    return this;
  }

  setTotalRecipients(totalRecipients) {
    this.metrics.totalRecipients = totalRecipients;
    return this;
  }

  setWinbackRate(winbackRate) {
    this.metrics.winbackRate = winbackRate;
    return this;
  }

  build() {
    return this.metrics;
  }
}
